import Navbar from "../components/Navbar";
import CList from "../components/CList";

const Home = () => {
  return (
    <div>
      <Navbar />

      <CList />
    </div>
  );
};

export default Home;
